var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar__logo title"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:(_vm.title ? _vm.$t_(_vm.title) : _vm.$t_('APP_TITLE_GO_HOME')),expression:"title ? $t_(title) : $t_('APP_TITLE_GO_HOME')",modifiers:{"left":true}}],attrs:{"href":_vm.basePath}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("To"),_c('span',[_vm._v("Sca")])])
}]

export { render, staticRenderFns }